<i18n>
{
  "cl": {
    "settings": {
      "title": "Configuración"
    },
    "menu1": {
      "title": "Feature Toggle",
      "id": "feature-toggle"
    },
    "menu2": {
      "title": "Permisos a usuarios",
      "id": "user-permissions"
    },
    "menu3": {
      "title": "Grupos de permisos",
      "id": "permission-groups"
    },
    "menu4": {
      "title": "Políticas de riesgo",
      "id": "risk-policies"
    }
  },
  "pe": {
    "settings": {
      "title": "Configuración"
    },
    "menu1": {
      "title": "Feature Toggle",
      "id": "feature-toggle"
    },
    "menu2": {
      "title": "Permisos a usuarios",
      "id": "user-permissions"
    },
    "menu3": {
      "title": "Grupos de permisos",
      "id": "permission-groups"
    },
    "menu4": {
      "title": "Políticas de riesgo",
      "id": "risk-policies",
      "submenu": [
        { "title": "PYME", "id": "sme" },
        { "title": "Hipotecario", "id": "mortgage" }
      ]
    }
  },
  "br": {
    "settings": {
      "title": "Configurações"
    },
    "menu1": {
      "title": "Feature Toggle",
      "id": "feature-toggle"
    },
    "menu2": {
      "title": "Usuários",
      "id": "users"
    },
    "menu3": {
      "title": "Configurar secciones",
      "id": "configure-sections"
    },
    "menu4": {
      "title": "Risk policies",
      "id": "risk-policies",
      "submenu": [
        { "title": "Hipotecario", "id": "mortgage" },
        { "title": "Home Equity", "id": "home-equity" }
      ]
    }
  }
}
</i18n>
<template>
  <div>
    <div class="columns pt-2">
      <div id="settings-container" class="mt-6 column">
        <b-button v-if="!openSidebar" icon-left="angle-left" class="mb-4" @click="setOpenSidebar">Regresar</b-button>
        <div class="is-flex">
          <div :class="[openSidebar ? 'sidebar-section' : 'sidebar-section-display-none']">
            <div class="card-item">
              <h2 class="pl-4 is-size-4">{{ $t( 'settings.title' ) }}</h2>
              <SecondarySidebar
                :open-sidebar="openSidebar"
                :options="options"
                :section-active="sectionActive"
                @sectionActive="setActiveSection"
                @openSidebar="setOpenSidebar" />
            </div>
          </div>
          <div v-if="!openSidebar || shouldSettingContentBeSeen" :class="[openSidebar ? 'is-flex-grow-2 setting-content ml-4' : 'is-flex-grow-2 setting-content']">
            <div>
              <div v-if="sectionActive == 0">
                <FeaturesToggles v-if="$i18n.locale === 'cl'" />
              </div>
              <div v-if="sectionActive == 1">
                <UsersPermissions :restart="restartComponents" />
              </div>
              <div v-if="sectionActive == 2">
                <Sections @sectionUpdate="refreshSectionUserFeatures" />
              </div>
              <div v-if="sectionActive == 3">
                <RiskPolicy />
              </div>
            </div>
          </div>
        </div>
        <!-- <Tabs
          :options="options">
          <template #0>
            <FeaturesToggles v-if="$i18n.locale === 'cl'" />
            <Operations v-if="$i18n.locale === 'br'" />
          </template>
          <template #1>
            <UsersPermissions :restart="restartComponents" />
          </template>
          <template #2>
            <Sections @sectionUpdate="refreshSectionUserFeatures" />
          </template>
        </Tabs> -->
      </div>
    </div>
  </div>
</template>

<script>
// import Tabs from '@/ui/components/Tabs.vue';
import FeaturesToggles from '@/ui/views/internal/settings/FeaturesToggles.vue';
import UsersPermissions from '@/ui/views/internal/settings/UsersPermissions.vue';
import Sections from '@/ui/views/internal/settings/Sections.vue';
import VueBreakpointMixin from 'vue-breakpoint-mixin';
import RiskPolicy from '@/ui/views/internal/settings/risk-policies/RiskPolicy.vue';
import SecondarySidebar from '../../../components/SecondarySidebar.vue';

export default {
  name: 'Settings',
  components: {
    // Tabs,
    FeaturesToggles,
    UsersPermissions,
    Sections,
    SecondarySidebar,
    RiskPolicy

  },
  mixins: [VueBreakpointMixin],
  data() {
    return {
      options: [
        { label: this.$t('menu1.title'), id: this.$t('menu1.id'), icon: 'cog' },
        { label: this.$t('menu2.title'), id: this.$t('menu2.id'), icon: 'lock' },
        { label: this.$t('menu3.title'), id: this.$t('menu3.id'), icon: 'users-rectangle' },
        {
          label: this.$t('menu4.title'),
          id: this.$t('menu4.id'),
          icon: 'sliders',
          submenu: Array.isArray(this.$t('menu4.submenu')) && this.$t('menu4.submenu').length > 0 ? this.$t('menu4.submenu') : undefined
        }
      ],
      restartComponents: true,
      screenWidth: window.innerWidth,
      settingContentVisible: false,
      openSidebar: true,
      sectionActive: 0
    };
  },
  computed: {
    shouldSettingContentBeSeen() {
      // If the screen width is less than or equal to 910px (an example threshold for mobile screens),
      // use the openMenu prop to control the sidebar's openness.
      if (this.screenWidth <= 768) {
        return this.settingContentVisible;
      }
      // On desktop screens, the sidebar should always be open.
      return true;
    }
  },
  async mounted() {
    // Add an event listener to watch for window resize events
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      // Update the screenWidth property when the window is resized
      this.screenWidth = window.innerWidth;
    },
    refreshSectionUserFeatures() {
      this.restartComponents = !this.restartComponents;
    },
    setOpenSidebar(openSidebar) {
      this.openSidebar = openSidebar;
    },
    setActiveSection(sectionActive) {
      this.sectionActive = sectionActive;
    }
  }
};
</script>

<style>
.sidebar-section {
  width: 100%;
  max-width: 285px;
}

.sidebar-section-display-none {
  display: none;
}

@media screen and (max-width: 768px) {
  .sidebar-section {
  max-width: 100%;
}
}
</style>
